import { createUrl } from './base-url';

export const GlobleSettingsUrls = {
  updateSetting: (baseUrl: string) => createUrl(baseUrl, 'Account/updateGlobleSetting'),
  getSettings: (baseUrl: string) => createUrl(baseUrl, 'Account/getGlobleSettings'),

};
